import { debounce } from 'lodash-es';

export default {
  data() {
    return {
      windowWidth: 0,
      windowHeight: 0,
      tableHeightRow: {
        height: 0
      }
    };
  },

  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    handleResize: debounce(function() {
      // 业务逻辑
      const el = document.querySelector('.dialog-table');
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;
      // console.log('窗口尺寸变化:', this.windowWidth, this.windowHeight, el.getBoundingClientRect(), el.offsetTop, el.offsetHeight);

      if (el) {
        // 获取调用传递过来的数据
        const { bottomOffset } = this.tableHeightRow;
        // 获取距底部距离（用于展示页码等信息）
        const customHeight = bottomOffset || 62;
        // 计算列表高度
        const height = this.windowHeight - el.getBoundingClientRect().top - customHeight;
        // 设置高度
        this.tableHeightRow.height = (height <= 200) ? 200 : height;
      }
    }, 300)
  }
};
